import { render, staticRenderFns } from "./FundingCompetitionSubmission.vue?vue&type=template&id=3525c1dc&"
import script from "./FundingCompetitionSubmission.vue?vue&type=script&lang=js&"
export * from "./FundingCompetitionSubmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports